import { render, staticRenderFns } from "./ControlSwitch.vue?vue&type=template&id=0de610cc&scoped=true&functional=true&"
import script from "./ControlSwitch.vue?vue&type=script&lang=js&"
export * from "./ControlSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ControlSwitch.vue?vue&type=style&index=0&id=0de610cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "0de610cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
